import { render, staticRenderFns } from "./PageSix.vue?vue&type=template&id=16494e92&scoped=true"
import script from "./PageSix.vue?vue&type=script&lang=js"
export * from "./PageSix.vue?vue&type=script&lang=js"
import style0 from "./PageSix.vue?vue&type=style&index=0&id=16494e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16494e92",
  null
  
)

export default component.exports